// Angular
import { FormsModule } from '@angular/forms';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// ng-bootstrap
import { NgbModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { TranslateModule } from '@ngx-translate/core';

// Solar
import { SolarFormModule, SolarHeaderModule, ChipModule } from "@solar/components";
import { SolarVortexModule } from '@solar/vortex';

// Notifications
import { NotificationsModule } from './notifications/notifications.module';

// Download mobile app
import { DownloadMobileAppModule } from './mobile/download-mobile-app.module';

// Components
import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { NoWidgetComponent } from './no-widget/no-widget.component';
import { SearchControlComponent } from './search/search-control.component';
import { SearchBarComponent } from './search/search-bar.component';
import { SessionExpiredComponent } from './session-expired/session-expired.component';
import { UserDropdownComponent, UserProfileSwitchComponent, UserProfileSwitchItemComponent, UserProfileSwitchRedirectComponent } from './user';
import { FormatLanguagePipe } from './pipes/format-language.pipe';
import { ManageMFADeviceModule } from './manage-mfa-device/manage-mfa-device.module';
import { FeatureFlagModule } from './feature-flag/feature-flag.module';
import { CelineFooterComponent } from './celine-footer/celine-footer.component';
import { ToasterService } from '@threshold/services/toast.service';
import { LogoutComponent } from './logout/logout.component';
import { CelineScriptComponent } from './script/celine-script.component';
import { ComplaintsComponent } from './complaints/complaints.component';
import { NewsflashComponent } from './newsflash/newsflash.component';

export const COMPONENTS = [
	AppComponent,
	SearchControlComponent,
	SearchBarComponent,
	SessionExpiredComponent,
	FooterComponent,
	NoAccessComponent,
	NoWidgetComponent,
	UserDropdownComponent,
	UserProfileSwitchComponent,
	UserProfileSwitchItemComponent,
	UserProfileSwitchRedirectComponent,
	CelineFooterComponent,
	LogoutComponent,
	CelineScriptComponent,
	ComplaintsComponent,
	NewsflashComponent
];

@NgModule({
	imports: [
		FormsModule,
		CommonModule,
		RouterModule,
		HttpClientModule,
		SolarFormModule,
		SolarHeaderModule,
		ChipModule,
		NgbModule.forRoot(),
		TranslateModule.forChild({}),
		NotificationsModule,
		DownloadMobileAppModule,
		ManageMFADeviceModule,
		FeatureFlagModule,
		ManageMFADeviceModule,
		SolarVortexModule
	],
	providers: [
		NgbModal,
		ToasterService
	],
	declarations: [
		COMPONENTS,
		FormatLanguagePipe
	],
	entryComponents: COMPONENTS,
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class ThresholdComponentsModule {
	constructor () { }
}

export * from './app.component';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/index.ts